import clsx from "clsx";
import styles from "./index.module.scss";
import { WhiteLoadingSvg, BlackLoadingSvg } from "@/assets/icons";

type LoadingProps = {
  className?: string;
  width?: number;
  height?: number;
  isBlack?: boolean;
}

const Loading = (props: LoadingProps) => {
  const {
    className,
    width = 20,
    height = 20,
    isBlack = false,
  } = props;

  return (
    <>
      {isBlack ? (
        <BlackLoadingSvg
          className={clsx(styles["loading"], className)}
          width={width}
          height={height}
        ></BlackLoadingSvg>
      ) : (
        <WhiteLoadingSvg
          className={clsx(styles["loading"], className)}
          width={width}
          height={height}
        ></WhiteLoadingSvg>
      )}
    </>
    
  )
}

export default Loading;